import { Flag, Globe2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Users, UserCheck, FileCheck2, FileClock, FileX2, ClipboardList } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";

const KPI = ({ icon: Icon, label, value, sub, cls, testid, onClick, active }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`rounded-2xl border p-4 bg-white text-start transition hover:shadow-md hover:-translate-y-0.5 cursor-pointer ${cls || "border-slate-200"} ${active ? "ring-2 ring-blue-400" : ""}`}>
    <div className="flex items-center justify-between">
      <span className="text-sm text-slate-500">{label}</span>
      <Icon className="h-4 w-4 text-slate-400" />
    </div>
    <div className="mt-2 font-mono-nums text-2xl font-extrabold text-slate-800">{value}</div>
    {sub && <div className="mt-0.5 text-xs text-slate-400">{sub}</div>}
  </button>
);

export const EmpDocsStats = ({ className = "", reloadKey, onPick, activeKey }) => {
  const { t } = useLang();
  const [d, setD] = useState(null);

  useEffect(() => {
    let ok = true;
    api.overview().then((res) => ok && setD(res)).catch(() => {});
    return () => { ok = false; };
  }, [reloadKey]);

  if (!d) return null;
  const p = (k) => ({ onClick: () => onPick?.(k), active: activeKey === k });

  return (
    <div className={className} data-testid="emp-docs-stats">
      <h3 className="font-heading text-sm font-bold text-slate-500 mb-3">{t("dash.overview.empDocsHead")} {onPick && <span className="font-normal text-xs text-blue-500">— اضغط على أي مربع لعرض موظفيه</span>}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-3">
        <KPI {...p("employees")} testid="emp-stat-employees" icon={Users} label={t("dash.overview.employees")} value={d.employees_total} sub={t("dash.overview.nActive", { n: d.employees_active })} cls="border-blue-100 bg-blue-50/40" />
        <KPI {...p("active")} testid="emp-stat-active" icon={UserCheck} label={t("dash.overview.active")} value={d.employees_active} />
        <KPI {...p("saudis")} testid="emp-stat-saudi" icon={Flag} label="السعوديون" value={d.saudi_total ?? 0} sub={`${d.saudi_active ?? 0} نشط`} cls="border-emerald-200 bg-emerald-50/50" />
        <KPI {...p("residents")} testid="emp-stat-residents" icon={Globe2} label="المقيمون" value={d.resident_total ?? 0} sub={`${d.resident_active ?? 0} نشط`} cls="border-sky-200 bg-sky-50/50" />
        <KPI {...p("docs-total")} testid="emp-stat-docs-total" icon={ClipboardList} label={t("dash.overview.docsTotal")} value={d.docs_total} />
        <KPI {...p("docs-valid")} testid="emp-stat-valid" icon={FileCheck2} label={t("dash.overview.valid")} value={d.docs_valid} cls="border-emerald-100 bg-emerald-50/40" />
        <KPI {...p("docs-expiring")} testid="emp-stat-expiring" icon={FileClock} label={t("dash.overview.expiring")} value={d.docs_expiring} cls="border-amber-100 bg-amber-50/40" />
        <KPI {...p("docs-expired")} testid="emp-stat-expired" icon={FileX2} label={t("dash.overview.expired")} value={d.docs_expired} cls="border-red-100 bg-red-50/40" />
      </div>
    </div>
  );
};
